import wretch from 'wretch';
import rootUrls from '../../utils/rootUrls';
const getApi = (environment, token) => {
    const instance = wretch(rootUrls[environment]);
    if (token) {
        instance.auth(token);
    }
    return instance;
};
export default getApi;
